<!-- 历史界面组件 -->
<template>
    <div>
        <el-form :inline="true" :model="historyForm" class="demo-form-inline">
            <el-form-item label="车辆型号名称">
                <el-input v-model="historyForm.modelName" placeholder="请输入车辆型号名称"></el-input>
            </el-form-item>
  
            <el-form-item  >
                <el-button type="primary" @click="handleQueryHistorySubmit">查询</el-button>
            </el-form-item>
        </el-form>

        <!-- 表格 -->
        <el-table :data="vehicleList">
            <el-table-column
                prop="current.plateNo"
                label="车牌号"
              
                width="180">
            </el-table-column>

            <el-table-column
                prop="factory.registerDate"
                label="登记日期"
                width="180">
            </el-table-column>

            <el-table-column
                prop="factory.vehicleTradeName"
                label="车型"
                width="180">
            </el-table-column>
             <el-table-column
                prop="bidPrice"
                label="中标价格"
                width="180">
            </el-table-column>   
            <el-table-column
                prop="current.ownership"
                label="所有人性质"
                width="180">
            </el-table-column>

            <el-table-column
                prop="current.useCharacter"
                label="营运"
                width="180">
            </el-table-column>

            <el-table-column label="操作"  width="120" fixed="right">
                <template slot-scope="scope">
                     <el-button
                        size="mini"
                        @click="handleShowDetail(scope.$index, scope.row)">
                        详情
                    </el-button>
                </template>

            </el-table-column>

        </el-table>

        <pagination  v-show="totalRow>0" :total="totalRow" :page.sync="page.pageNumber" 
        :limit.sync="page.pageLimit" 
        @pagination="handleQueryHistorySubmit">
        </pagination>

        <!-- dialog 对话框 -->
        <el-dialog append-to-body title="车辆详情" :visible.sync="dialogDetailVisible">
            <el-descriptions class="margin-top" :title="vehicleDetail.factory.vehicleModel" :column="3"  border>
                <template slot="extra">
                    <el-button type="primary" size="small" @click="handleCloseDialog">关闭</el-button>
                </template>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        车辆型号
                    </template>
                    {{vehicleDetail.factory.vehicleTradeName}}
                </el-descriptions-item>
                <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-mobile-phone"></i>
                    中标价格
                </template>
                {{ vehicleDetail.bidPrice }}
                </el-descriptions-item>
        <el-descriptions-item>
        <template slot="label">
            <i class="el-icon-location-outline"></i>
            登记日期
        </template>
        {{  vehicleDetail.factory.registerDate}}
        </el-descriptions-item>
        <el-descriptions-item>
        <template slot="label">
            <i class="el-icon-tickets"></i>
            使用性质
        </template>
        {{vehicleDetail.current.useCharacter}}
        </el-descriptions-item>

        <el-descriptions-item>
            <template slot="label">
                <i class="el-icon-office-building"></i>
                所有人性质
            </template>
        {{  vehicleDetail.current.ownership}}
        </el-descriptions-item>
        
        <el-descriptions-item>
            <template slot="label">
            <i class="el-icon-office-building"></i>
            车牌号
        </template>
            {{  vehicleDetail.current.plateNo}}
        
        </el-descriptions-item>
        
        
            </el-descriptions>
            <el-image 
                style="width: 100px; height: 100px"
                v-for="urlItem in vehicleDetail.damage.imgUrls" :key="urlItem" :src="urlItem"
                :preview-src-list="vehicleDetail.damage.imgUrls">
            </el-image> 
        </el-dialog>

    </div>   
</template>

<script>
import {getCaseListByVehicleModel} from '@/api/vehicle/case'
export default {
    name: 'HistoryView',
    
    props:{
        vehicleName:'',
    },
    data() {
        return{
            
            dialogDetailVisible:false,
            historyForm:{
                modelName:this.vehicleName,
            },
            totalRow:0,//总数
            page: {
                pageNumber: 1,
                pageLimit: 10,
            },
            vehicleList:[],
            vehicleDetail:{
                factory:{},
                current:{},
                damage:{},
            },
        }
    },
    methods:{

        handleShowDetail(id,objDetail){
            this.dialogDetailVisible=true;
            this.vehicleDetail=objDetail;

            let data=this.vehicleDetail.damage.imgUrls
            if(!Array.isArray(data)){
                this.vehicleDetail.damage.imgUrls=JSON.parse(data);
            }
           
        },
        handleCloseDialog(){
            this.dialogDetailVisible=false;
        },

        //查询历史记录
        handleQueryHistorySubmit(){

            var para=Object.assign({"vehicleModel":this.historyForm.modelName},this.page)
            
             getCaseListByVehicleModel(para)
            .then(res=>{
                this.totalRow=res.data.totalRow;
                this.vehicleList=res.data.list;
          
            })
            .catch(error=>{
                
            })
        },
      
    }
}
    
</script>